const setIsServerConnectable = (state, payload) => {
  state.indicators.isServerConnectable = payload
}

const setShowingSlideGrid = (state, payload) => {
  state.indicators.showingSlideGrid = payload
}

const setIsWelcomePopupShowing = (state, payload) => {
  state.indicators.isWelcomePopupShowing = payload
}

export default {
  setIsServerConnectable,
  setShowingSlideGrid,
  setIsWelcomePopupShowing,
}
